<template>
  <Card class="card">
    <template #title>
      Concurrent Sites
      <Button
        icon="pi pi-times"
        aria-label="Close"
        class="p-button-rounded p-button-secondary p-button-text"
        style="position: fixed; right: 10px"
        @click="close()"
      />
    </template>
    <template #content>
      <div class="formgrid grid" style="height: 50vh">
        <div class="field col-12">
          <div class="field col-12 md:col-2">
            <div class="field-checkbox">
              <Checkbox inputId="neighbor" v-model="project.hasNeighbors" :binary="true" v-if="!project.readonly"> </Checkbox>
              <label for="neighbor" style="width: 100%">Concurrent Sites</label>
            </div>
          </div>
          <div v-if="project.hasNeighbors || project.unregisteredNeighbours.length > 0" class="formgrid grid">
            <div class="field col-12 md:col-10" v-if="!project.readonly">
              <InputText v-if="!project.readonly" v-model="unregSiteName" style="width: 100%" placeholder="Project Name" />
            </div>
            <div class="field col-12 md:col-2" v-if="!project.readonly">
              <Button
                icon="pi pi-plus"
                :icon="slotProps.data.deleting"
                class="p-button-rounded p-button-secondary p-button-text"
                aria-label="Add Project"
                @click="
                  project.unregisteredNeighbours.push({ name: unregSiteName, id: project.unregisteredNeighbours.length + 1, projectId: project.id });
                  unregSiteName = '';
                "
                v-tooltip="'Add Project'"
                :disabled="unregSiteName == ''"
              />
            </div>
            <div class="field col-12">
              <DataTable
                :value="project.unregisteredNeighbours"
                v-if="project.unregisteredNeighbours.length > 0"
                class="p-datatable-sm field col-12 md:col-5"
                :scrollable="true"
                scrollHeight="300px"
                style="width: 100%"
              >
                <Column field="name" header="Project Name" style="min-width: 90%"> </Column>
                <Column style="width: 5%" v-if="!project.readonly">
                  <template #body="slotProps">
                    <Button
                      icon="pi pi-times"
                      :icon="slotProps.data.deleting"
                      aria-label="Delete"
                      class="p-button-rounded p-button-secondary p-button-text p-button-danger"
                      @click="deleteNeighbor(slotProps.data)"
                      v-tooltip="'Delete'"
                    />
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="formgrid grid" v-if="!project.readonly">
        <div class="field col-8"></div>
        <div class="field col-2">
          <Button label="Save" :icon="savingProject" style="width: 100%" @click="save(false)" :disabled="saving" />
        </div>
        <div class="field col-2">
          <Button label="Save & Close" :icon="savingProject2" style="float: right; width: 100%" @click="save(true)" :disabled="saving" />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
import DateHelper from "@/helper/DateHelper";
import { disable } from "ol/rotationconstraint";

export default {
  data() {
    return {
      project: this.getCurrentProject(),

      savingProject: "pi pi-save",
      savingProject2: "pi pi-save",

      unregSiteName: "",
    };
  },
  computed: {},
  methods: {
    close() {
      this.$router.replace({ path: "/" });
    },
    getCurrentProject() {
      return this.$store.getters.currentProject;
    },
    deleteNeighbor(target) {
      if (target.id_0 > -1) {
        let props = this;
        props.axios
          .delete(`${props.apiEndpoint}unregsites/${target.id_0}`)
          .then(function (response) {})
          .catch((error) => console.log(error));
      }
      this.project.unregisteredNeighbours = this.project.unregisteredNeighbours.filter((n) => n.id != target.id);
    },
    save(close) {
      if (close) {
        this.savingProject2 = "pi pi-spin pi-spinner";
      } else {
        this.savingProject = "pi pi-spin pi-spinner";
      }
      let props = this;
      let projectCopied = { ...props.project, equipments: [] };
      props.axios
        .post(`${props.apiEndpoint}project?id=${props.project.id}`, projectCopied)
        .then(function (response) {
          let savedProject = { ...response.data, equipments: props.project.equipments };
          savedProject = DateHelper.fixUTCDate(savedProject);
          console.log("this projectid = ", props.project.id);
          console.log(savedProject);
          props.$store.dispatch("setCurrentProject", { project: savedProject });
          props.savingProject = "pi pi-save";
          props.savingProject2 = "pi pi-save";
          if (close) {
            props.close();
          }
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {
    this.project.hasNeighbors = this.project.unregisteredNeighbours.length > 0;
    console.log(this.project);
  },
};
</script>

<style lang="less">
.p-inputnumber .p-inputnumber-input {
  width: 80%;
}

.ddEquipment {
  width: 250px;
}

#equipmentInput .p-datatable .p-datatable-tbody > tr > td {
  padding: 0 0.5rem !important;
  font-size: 12px;
}

.p-dropdown-label {
  font-size: 12px !important;
}

.p-dropdown-item {
  font-size: 12px !important;
}

#equipmentInput > div > table {
  width: 100%;
}

.inputnumber > input {
  font-size: 12px;
}

.p-multiselect-label {
  font-size: 12px;
}

.p-multiselect-item > span {
  font-size: 12px;
}

.p-frozen-column {
  z-index: 2;
}

.p-datatable-thead {
  z-index: 3 !important;
}

tbody.p-datatable-tbody.p-datatable-frozen-tbody {
  z-index: 4 !important;
}

.p-menuitem-text {
  text-align: left;
}

// .p-panelmenu-icon {
//     order: 1; // to be the first item on right side.
// }

.p-menuitem-icon {
  order: 1; // to be the first item on right side.
  margin-left: 5px;
}

#taskTree .p-menuitem-icon.pi.pi-check {
  color: green !important;
}

.p-menuitem-text {
  flex-grow: 1; // to fill the whole space and push the icon to the end
}

.p-tooltip {
  width: auto !important;
  max-width: 400px !important;
}

#pmeList .p-listbox-item {
  flex: 0 0 auto;
  width: 33.3333%;
  padding-top: 0;
  padding-bottom: 0;
}

#qpmeList .p-listbox-item {
  flex: 0 0 auto;
  width: 33.3333%;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
<style scoped>
.card {
  height: 65vh;
  width: 50vw;
  position: absolute;
  transform: translate(50%, 2%);
}

.upload {
  height: 30vh;
  width: 40vw;
  position: absolute;
  transform: translate(80%, 50%);
}

.inputnumber {
  margin: 5px 0;
  height: 30px;
  width: 100px;
}
</style>
